import { render, staticRenderFns } from "./AddRate.vue?vue&type=template&id=57c2cfeb&scoped=true"
import script from "./AddRate.vue?vue&type=script&lang=js"
export * from "./AddRate.vue?vue&type=script&lang=js"
import style0 from "./AddRate.vue?vue&type=style&index=0&id=57c2cfeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2cfeb",
  null
  
)

export default component.exports